import { CategoryRepository } from '../../domain/repositories/category.repository';

export class DeleteCategoryUseCase {
  constructor(private readonly categoryRepository: CategoryRepository) {}

  async execute(id: string): Promise<void> {
    return this.categoryRepository.deleteCategory(id);
  }
}
